# frozen_string_literal: true

require_relative 'base'

module Engine
  module Action
    class SellCompany < Base
      attr_reader :entity, :company, :price

      REQUIRED_ARGS = %i[company price].freeze

      def initialize(entity, company:, price:)
        super(entity)
        @company = company
        @price = price
      end

      def self.h_to_args(h, game)
        {
          company: game.company_by_id(h['company']),
          price: h['price'],
        }
      end

      def args_to_h
        {
          'company' => @company.id,
          'price' => @price,
        }
      end
    end
  end
end
